import React from 'react';
import PieChartComponent from '../../NecttosComp/Charts/StudentsCount';

export default function StaticstcsPieChart({ data, title, first }) {
	return (
	  <div 
		className={`
		  flex rounded-2xl mt-1 shadow-md 
		  bg-[#1777CC] flex-col items-center 
		   p-1 dark:to-[#1c5298d2] 
		  dark:from-[#1c5298c8] dark:bg-gradient-to-br justify-between
		`} 
		style={{ 
		  width: '100%',
		  height: first? "400px": '350px' 
		}}
	  >
		<h3 className='text-white text-lg'>{title}</h3>
		<div className='flex-1 w-full'>
		  <PieChartComponent 
			data={data} 
			legendNeeded={false} 
			customizedLabel 
			height={first? "250px" :"200px" }
		  />
		</div>
		  <ul className='w-full grid grid-cols-2 gap-2 mt-4'>
			{data.map((item, index) => (
			  <li key={index} className='flex items-center gap-2'>
				<div 
				  className='w-4 h-4 rounded' 
				  style={{ backgroundColor: item.color }}
				/>
				<span className='text-sm text-white'>{item.name}</span>
			  </li>
			))}
		  </ul>
	  </div>
	);
  }